import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=98e403f2&"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports